import clsx from 'clsx';
import React from 'react';
import { H3, Li, Span, Ul, simpleCard } from '@/components/ui';

export interface CardItem {
  title: string;
  icon?: React.ReactNode;
  list: string[];
}

export interface DynamicCardSectionProps {
  cards: CardItem[];
  columns?: number;
  rows?: number;
  className?: string;
}

const DynamicCardSection: React.FC<DynamicCardSectionProps> = ({
  cards,
  columns,
  rows,
  className,
}) => {
  const gridClass =
    rows && columns
      ? `grid-${rows}-rows-column-${columns}`
      : columns
        ? `grid-column-${columns}`
        : cards.length >= 6
          ? 'grid-column-6'
          : cards.length === 5
            ? 'grid-column-5'
            : cards.length === 4
              ? 'grid-column-4'
              : cards.length === 3
                ? 'grid-column-3'
                : cards.length === 2
                  ? 'grid-column-2'
                  : 'grid-column-1';

  return (
    <section className={clsx('container-section', className)}>
      <div className={clsx('w-full', gridClass)}>
        {cards.map((card, idx) => (
          <article key={idx} className={simpleCard()}>
            <div>
              <div className="mb-4 flex items-center justify-between gap-3">
                <H3 className="page-card-title">{card.title}</H3>
                {card.icon ? (
                  <Span className="page-highlight-icon shrink-0 [&_svg]:h-5 [&_svg]:w-5" aria-hidden>
                    {card.icon}
                  </Span>
                ) : null}
              </div>
              <div className="hr" />
              <Ul className="page-card-list mt-4 space-y-2">
                {card.list.map((item, i) => (
                  <Li key={i}>{item}</Li>
                ))}
              </Ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default DynamicCardSection;
